import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "#ifihadglass - the app I want to build",
  "description": "",
  "published": "2013-02-28T00:00:00.000Z",
  "redirect_from": ["/blog/ifihadglass-the-app-i-want-to-build/swizec/6035"],
  "categories": "Glass, Google, Google Glass, Uncategorized, User interface, Wearable computer",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`For about a year now `}<a parentName="p" {...{
        "href": "http://google.com",
        "title": "Google"
      }}>{`Google`}</a>{` has been teasing us with its `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Wearable_computer",
        "title": "Wearable computer"
      }}>{`wearable computing`}</a>{` idea - Glass.`}</p>
    <p>{`And for just as long, people have been making fun of the concept. Calling it anything from utterly ridiculous, to a despicable invasion into everybody's privacy. The `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Running_gag",
        "title": "Running gag"
      }}>{`running joke`}</a>{` on the internet is that you should walk up to anyone wearing Google Glass and shout `}<em parentName="p">{`"Ok, Glass, google lemon party. Open all."`}</em></p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2013/02/longboard-glass-app.jpg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2013/02/longboard-glass-app.jpg",
          "alt": "longboard-glass-app",
          "title": "longboard-glass-app"
        }}></img></a></p>
    <p>{`Some have gone as far as calling it a useless idea that does nothing more than a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Smartphone",
        "title": "Smartphone"
      }}>{`smartphone`}</a>{` can already do for you.`}</p>
    <blockquote>
      <p parentName="blockquote">{`No to throw cold water here but Is it really? It seems to be rather trivial integration of currently known and available technologies with bit of miniaturization efforts. Nothing that 5 year old iPhone can't do with albeit more convenience. Space elevators, 100% artificial life form, fusion reactor of the size AA batteries - now that, my friend, would be sci-fi stuff.`}</p>
    </blockquote>
    <p>{`Which is just ridiculous, if you ask me. Glass isn't about being annoyed by notifications all day long, or about making calls without a phone (people with bluetooth headphones look ridiculous enough). Hell, Glass is pretty much useless in all but a few cases that Google shows in their `}<a parentName="p" {...{
        "href": "http://www.google.com/glass/start/how-it-feels/"
      }}>{`How Glass feels video`}</a>{`.`}</p>
    <p>{`Ugh, life logging. Taking pictures. Remotely sharing moments. Boring.`}</p>
    <p>{`Here's the stuff that might actually change the world as much as smartphones did a few years ago.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/02/Selection_152-1024x587.png",
        "alt": "Directions, while cycling",
        "title": "Directions, while cycling"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/02/Selection_153-1024x576.png",
        "alt": "Skiing directions",
        "title": "Skiing directions"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/02/Selection_154-1024x558.png",
        "alt": "Artist's reference",
        "title": "Artist's reference"
      }}></img></p>
    <p><em parentName="p">{`That's`}</em>{` what Glass is really bringing to the table. The ability to look at things without using your hands. There are countless smartphone zombies out there, walking through town, never looking up from their sci-fi slab of glass.`}</p>
    <p>{`Sit on a bench some time and observe. Most people are either walking around like zombies, or randomly stopping in the middle of the street to look something up.`}</p>
    <p>{`It's ridiculous.`}</p>
    <h2 {...{
      "id": "sports-theres-your-future"
    }}>{`Sports, there's your future`}</h2>
    <p>{`The real advantage, however, will come for sports.`}</p>
    <p>{`Ever used `}<a parentName="p" {...{
        "href": "http://www.runkeeper.com/",
        "title": "RunKeeper"
      }}>{`Runkeeper`}</a>{` or Strava to log your activity? Running with a smartphone in your pocket is a bit annoying, it keeps flopping about in your pocket and doesn't do a good job of communicating with you. Looking up your current pace, running time or whatever ... it's a pain.`}</p>
    <p>{`Not only is running while looking down at your phone kind of dangerous, it also hurts your form, the phone is utterly disgusting and covered in sweat by now, and the screen is shaking so much that you can barely see anything without stopping.`}</p>
    <p>{`Glass might solve that with a good enough app.`}</p>
    <p>{`The situation becomes even worse when you're, for instance, longboarding.`}</p>
    <p>{`Here you are, bombing down a hill ... no idea how fast you are going and no way of looking up safely, unless you know the track by heart you have no idea what the next bend is going to be like and so on. There isn't even an app for that because it would be useless, you can't just look at your phone while traveling 50mph down a hill on a thin piece of wood.`}</p>
    <p>{`I mean you could, but please don't.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2013/02/longboard-glass-app1.jpg",
        "alt": "A 3min mockup of the Glass Longboard App",
        "title": "A 3min mockup of the Glass Longboard App"
      }}></img></p>
    <p>{`The app I want to build would behave a bit like driving instructions in rally games. In a corner of your vision, neatly packed, information about the next curve, your current speed, possibly suggest good breaking/sliding points. Stuff like that.`}</p>
    <p>{`That alone would make having Glass totally worth it for me.`}</p>
    <p>{`And yes, I `}<em parentName="p">{`would`}</em>{` do adrenalyne sports with a $1500 piece of tech on my face. Especially if I could fit it on my normal glasses.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.tmcnet.com/social-spotlight/2013/02/what-would-i-do-ifihadglass.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/146846838_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://blog.tmcnet.com/social-spotlight/2013/02/what-would-i-do-ifihadglass.html"
        }}>{`What Would I Do #IfIHadGlass?`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.makezine.com/2013/02/22/ifihadglass-the-things-that-i-would-do/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/147387350_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://blog.makezine.com/2013/02/22/ifihadglass-the-things-that-i-would-do/"
        }}>{`#ifihadglass, the Things I Would Do...`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.theverge.com/2013/2/20/4006748/google-project-glass-explorer-edition-pre-order"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/146699858_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.theverge.com/2013/2/20/4006748/google-project-glass-explorer-edition-pre-order"
        }}>{`Google expands Glass pre-orders to 'creative individuals' with #ifihadglass competition`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.besttechie.com/2013/02/20/google-shows-off-google-glass-ui-and-launches-ifihadglass-campaign/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/146726081_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.besttechie.com/2013/02/20/google-shows-off-google-glass-ui-and-launches-ifihadglass-campaign/"
        }}>{`Google Shows Off Google Glass UI And Launches #IfIHadGlass Campaign`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=46c01b46-354a-4033-a7a4-3354e1f0539c",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      